import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDividerModule } from '@angular/material/divider';
import { IconModule } from '@visurel/iconify-angular';
import { MatButtonModule } from '@angular/material/button';
import { NewsComponent } from './news.component';
import { NewsModalComponent } from './news-modal/news-modal.component';

@NgModule({
  declarations: [NewsComponent, NewsModalComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    FlexLayoutModule,
    MatDividerModule,
    IconModule,
    MatButtonModule,
    MatTooltipModule,
  ],

  exports: [NewsComponent],
})
export class NewsModule {}
